import {VatCalculator} from './base.js'

class HighlightVatCalculator extends VatCalculator{
    initialize() {
        super.initialize();
        let self = this;
        self.calcName = "Vydelit_nds"

        this.setupStatistic({
            calcName: 'nds',
            prefix: "Calculation_",
            printMessage: {
                message: "Print", 
                args: {
                    type: self.calcName 
                }
            },
            exportMessage: {
                message: "Export", 
                args: {
                    type: self.calcName 
                }
            },
            isStartedEventIgnore: true
        });
        this.sendStartedStatistics = false;

        this.irregularValueNames = ['decimalRate', 'decimalRateStr']; // For value changes tracking

        this.addInputField("#calculatedRateInput", "calculatedRate", {
            type: 'count', 
            options: { maxVal: 99, keyup: true },
        });

        $(".calc-div-input-fields .hardcoded-vat-rates.fixed-rates > a").click(function () {
            var val = $(this).html();
            $('#rateInput').val(val.substring(0, val.length - 1));
            self.decimalRate = false;
            self.autoSubmit();
        });
        
        $(".calc-div-input-fields .hardcoded-vat-rates.calculated-rates > a").click(function () {
            var val = $(this).html();
            $('#calculatedRateInput').val(val.split(`/`)[0]);
            $('.rate-field-div').removeClass('show-calculated-decimal');
            self.decimalRate = false;
            self.autoSubmit();
        });
        
        $(".calc-div-input-fields .hardcoded-vat-rates.calculated-decimal-rate > a").click(function () {
            self.decimalRateStr = $(this).html();
            $('.rate-field-div .calculated-decimal-val > span').html(self.decimalRateStr);
            $('.rate-field-div').addClass('show-calculated-decimal');
            self.decimalRate = true;
            self.autoSubmit();
            if (self.isActive && self.rate) {
                self.sendRateStatisticMessage(self.calcName, self.rate + "%");
            }
            else {
                self.sendRateStatisticMessage(self.calcName, self.decimalRateStr);
            } 
        });
        
        $(".calc-div-input-fields .calculated-decimal-val").click(function () {
            $('.rate-field-div').removeClass('show-calculated-decimal');
            $('#calculatedRateInput').focus();
            self.decimalRate = false;
            self.autoSubmit();
        });

        $(".sp2-dropdown dropdown-select").click(() => {
            self.autoSubmit();
        });

        $(".calc-div-input-fields .calculated-rates a").click(function(e){
            self.autoSubmit();
            if(self.isActive)
                self.sendRateStatisticMessage(self.calcName, self.calculatedRate+"/" + (100+self.calculatedRate));
        });

        this.inputTitle = "Сумма c НДС";
        this.rateTitle = "Ставка НДС";
    }

    afterParse(){
        const tooltipDiv1 = $("#tooltipDiv1");
        const tooltipDiv2 = $("#tooltipDiv2");
        if (this.rateType.value === 1) {
            $('#rateBlock').addClass('calculated-rate');
            this.calculatedRate =  this.calculatedRate || 0;
            $('#calculatedRateDivider').html((100 + this.calculatedRate));
            $(".hardcoded-vat-rates.fixed-rates").hide();
            $(".hardcoded-vat-rates.calculated-rates, .hardcoded-vat-rates.calculated-decimal-rate").show();
            this.rateTitle = "Расчётная ставка";
            this.calcName = "Vydelit_nds_raschetnaya";
            tooltipDiv1.hide();
            tooltipDiv2.show();
        } else {
            $('#rateBlock').removeClass('calculated-rate');
            $(".hardcoded-vat-rates.fixed-rates").show();
            $(".hardcoded-vat-rates.calculated-rates, .hardcoded-vat-rates.calculated-decimal-rate").hide();
            this.rateTitle = "Ставка НДС";
            this.calcName = "Vydelit_nds";
            this.decimalRate = false;
            tooltipDiv1.show();
            tooltipDiv2.hide();
        }
    }
    
    calculate(params) {
        let self = this;
        if(!this.decimalRate && (
            this.rate == null && !this.calculatedRate
            || this.rate == null && (this.rateType.value == 0 && this.calcName !== "Vydelit_nds_raschetnaya")
            || !this.calculatedRate && this.calcName == "Vydelit_nds_raschetnaya")){
            this.renderError();
            return false;
        }

        if(!this.sendStartedStatistics){
            let goalParams = {
                prefix: "", 
                message: "Vydelit"
            };
            this.sendStatisticMessage(goalParams);
            this.sendStartedStatistics = true;
        }

        let isFixedRateType = this.rateType.value == 1;

        this.mainBlockName = 'Сумма без НДС';
        this.formula2 = 'Сумма без НДС = Сумма с НДС − НДС';
        this.formula1 = !isFixedRateType
        ? 'НДС = Сумма с НДС × Ставка НДС ÷ (100% + Ставка НДС)'
        : 'НДС = Сумма с НДС × Расчётная ставка НДС';
        let calculatedRateStr = "";
        this.isPercent = true;
        if (!isFixedRateType) {
            calculatedRateStr = this.rate + '% ÷ (100% + ' + this.rate + '%)';
        } else {
            if ($(".rate-field-div").hasClass("show-calculated-decimal")) { 
                calculatedRateStr = self.decimalRateStr;
                this.rate = tools.parseLocaleFloat(self.decimalRateStr.slice(0, -1));
            } else {
                calculatedRateStr = this.calculatedRate + '/' + (100 + this.calculatedRate);
                this.rate = this.calculatedRate  / (100 + this.calculatedRate) * 100;
                this.isPercent = false;
            }
        }

        let sumWithVat = this.sumInput;
        let vat = tools.roundNumber(!isFixedRateType ? sumWithVat * this.rate / (100 + this.rate) : sumWithVat * this.rate / 100, 2);
        let sumNoVat = sumWithVat - vat;
        this.mainBlockVal = sumNoVat;

        this.formulaEx1 = tools.getLocaleSumInRubbles(sumWithVat) + ' × ' + calculatedRateStr + ' = '
        + tools.getLocaleSumInRubbles(vat) + ' (' + tools.verboseNumber(vat) + ')';
        this.formulaEx2 = tools.getLocaleSumInRubbles(sumWithVat) + ' &minus; ' + tools.getLocaleSumInRubbles(vat) + ' = ' + tools.getLocaleSumInRubbles(sumNoVat) + ' (' + tools.verboseNumber(sumNoVat) + ')';
        
        if(!this.isPercent)
            this.rate = this.calculatedRate + "/" + (100 + this.calculatedRate);

        return true;
    }
}

export {HighlightVatCalculator}